import { useEtapaEquipe } from "./use-etapa-equipe";
import { EtapaEquipeView } from "./view-etapa-equipe";
import type { EtapaEquipeProps } from "./types-etapa-equipe";

export function EtapaEquipe(props: EtapaEquipeProps) {
  const vm = useEtapaEquipe(props);

  return <EtapaEquipeView {...props} {...vm} />;
}

export type * from "./types-etapa-equipe";
